const faqItems = [
  {
    q: '糖心视频需要注册才能观看吗？',
    a: '完全不需要注册。糖心视频网所有影视资源均支持免费在线观看，打开网站即可直接播放，无需登录、无需会员、无需任何付费，真正实现即点即看。',
  },
  {
    q: '为什么有时候视频播放会卡顿？',
    a: '视频播放卡顿通常与您的网络环境有关。建议检查Wi-Fi或移动网络信号强度，关闭占用带宽的后台应用。糖心视频采用智能CDN加速和多线路切换技术，会自动为您选择最优播放节点，确保流畅观影体验。',
  },
  {
    q: '糖心视频支持哪些设备观看？',
    a: '糖心视频支持电脑、平板、手机等全终端设备。PC端通过浏览器访问即可，移动端可通过手机浏览器访问或下载糖心视频APP获得更佳观影体验，支持iOS和Android系统。',
  },
  {
    q: '网站上的影视内容多久更新一次？',
    a: '糖心视频每日定时更新，聚合西瓜视频、樱花视频、糖豆视频、樱桃视频等多平台最新资源。热播剧集通常播出后2小时内上线，电影下线后24小时内收录，确保您第一时间看到最新内容。',
  },
  {
    q: '糖心视频的影视资源是否完全免费？',
    a: '是的，糖心视频网所有内容完全免费。我们聚合各平台公开资源，通过技术手段为您提供一站式的便捷观影服务，不向用户收取任何费用，也没有隐藏收费项目。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full bg-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-[800px] mx-auto">
          <div className="text-center mb-10">
            <p className="text-xs md:text-sm font-medium text-primary-500 uppercase tracking-wide mb-2">常见问题</p>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">常见问题</h2>
            <p className="mt-2 text-sm text-foreground-500">关于糖心视频的常见疑问解答</p>
          </div>

          <div className="space-y-3">
            {faqItems.map((item, idx) => (
              <details key={idx} className="group bg-background-100 rounded-xl border border-background-200/70 overflow-hidden">
                <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                  <h3 className="text-sm md:text-base font-medium text-foreground-800 pr-4">{item.q}</h3>
                  <span className="w-5 h-5 flex items-center justify-center shrink-0 text-foreground-400 group-open:rotate-180 transition-transform duration-200">
                    <i className="ri-arrow-down-s-line text-lg"></i>
                  </span>
                </summary>
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}